<template>
  <v-card>
    <v-card-title class="mb-2">
      {{ $t('Dashboard.Presets.title') }}
    </v-card-title>
    <v-card-subtitle v-if="adminPresets.length">
      {{ $t('Dashboard.Presets.full') }}
    </v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col v-for="preset in adminPresets" cols="4" :key="'col_' + preset.name">
          <v-card 
            :color="selected === preset ? 'primary' : 'white'" 
            :dark="selected === preset"
            @click="selected = preset" 
            :key="'card_' + preset.name"
          >
            <v-card-title>
              {{ preset.name }}
              <v-spacer></v-spacer>
              <v-btn v-if="isAdmin && selected === preset" icon @click="remove" small>
                <v-icon>delete_forever</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              {{ preset.description }}
            </v-card-text>
            <v-card-actions>
              <v-icon class="mr-2">
                auto_awesome_mosaic
              </v-icon>
              {{ $t('Dashboard.Presets.basedOn') }} {{ preset.basedOn.name }}
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-subtitle>
      {{ $t('Dashboard.Presets.empty') }}
    </v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col cols="4" v-for="preset in basePresets" :key="preset.name">
          <v-card 
            :color="selected === preset ? 'primary' : 'white'" 
            :dark="selected === preset"
            @click="selected = preset" 
          >
            <v-card-title>{{ preset.name }}</v-card-title>
            <v-card-text>
              {{ preset.description }}
            </v-card-text>
            <v-card-actions>
              <v-icon class="mr-2">
                auto_awesome_mosaic
              </v-icon>
              <v-chip v-for="tag in preset.tags" :key="tag" label outlined class="mr-2">
                {{ tag }}
              </v-chip>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="selected === null" @click="apply">
        {{ $t('Global.Action.apply') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DEFAULT_TEMPLATES } from '@/config/dashboard'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'TemplateSelector',
  data: () => ({
    selected: null
  }),
  computed: {
    ...mapState('dashboard', [
      'presets'
    ]),
    ...mapState('qlik', [
      'apps'
    ]),
    ...mapGetters('auth', [
      'isAdmin'
    ]),
    availableApps () {
      return this.apps.map(app => app.qAppId)
    },
    adminPresets () {
      return this.presets.map(preset => ({
        ...preset,
        basedOn: this.basePresets.find(basePreset => basePreset.template === preset.template)
      }))
      .filter(preset => this.isRelevant(preset))
    },
    basePresets () {
      return DEFAULT_TEMPLATES.map(template => ({
        ...template,
        description: this.$t('Dashboard.Templates.' + template.template)
      }))
    },
    
  },
  methods: {
    ...mapActions('dashboard', [
      'loadPresets',
      'applyPreset',
      'removePreset'
    ]),
    async apply () {
      await this.applyPreset(this.selected)
      this.$emit('selected')
      this.selected = null
    },
    async remove () {
      await this.removePreset(this.selected)
      this.selected = null
    },
    // check if all slots use an app I have access to
    isRelevant(preset) {
      return Object.keys(preset.slots).every(slotKey => preset.slots[slotKey] === null || this.availableApps.includes(preset.slots[slotKey].qAppId))
    }
  },
  created () {
    this.loadPresets()
  }
}
</script>
